import { createContext } from 'react'
import type { OrganizationUnitPagedQuery } from '../dtos'
import type { IPaginationContext } from '../interfaces/Pagination/Pagination'

export const organizationListContext = createContext<IPaginationContext<OrganizationUnitPagedQuery>>({} as IPaginationContext<OrganizationUnitPagedQuery>)
